window.addEventListener('load', function () {
    if (typeof gform !== 'undefined') {
        gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
            const formId = up.settings.multipart_params.form_id,
                fieldId = up.settings.multipart_params.field_id;

            html = '<strong>' + file.name + '</strong>'
            + '<a class="gform_delete button bg--primary" href="javascript:gformDeleteUploadedFile(' + formId + ', ' + fieldId + ', this);">Remove</a> ';
            return html;
        });

        gform.addAction('gform_frontend_pages_evaluated', scheduleWashSystemFormUpdate, 999);
    }
});

/**
 * Form 12 can appear twice on the same page (wash-system block + legacy embed).
 * Duplicate IDs break GF pagination: `#gform_12 .gform_page` matches all 10 pages,
 * so step 1 renders as "Step 6 of 10" at 60%.
 */
function dedupeWashSystemGravityForms() {
    document.querySelectorAll('.section--wash-system .wash-system__form').forEach(function (formContainer) {
        const primaryForm = formContainer.querySelector('form[data-formid]');

        if (!primaryForm) {
            return;
        }

        const formId = primaryForm.dataset.formid;
        let duplicateIndex = 0;

        document.querySelectorAll('form[data-formid="' + formId + '"]').forEach(function (form) {
            if (form.closest('.section--wash-system .wash-system__form')) {
                return;
            }

            duplicateIndex++;
            isolateDuplicateGravityForm(form, duplicateIndex);
        });
    });
}

function isolateDuplicateGravityForm(form, index) {
    const suffix = '_wash_dup' + index;
    const wrapper = form.closest('.gform_wrapper');

    if (!wrapper || wrapper.dataset.gformDuplicate === 'true') {
        return;
    }

    wrapper.dataset.gformDuplicate = 'true';
    wrapper.hidden = true;
    wrapper.style.display = 'none';

    wrapper.querySelectorAll('[id]').forEach(function (node) {
        if (node.id) {
            node.id = node.id + suffix;
        }
    });
}

function updateWashSystemProgress(wrapper) {
    const form = wrapper.querySelector('form');

    if (!form) {
        return;
    }

    const pages = [...form.querySelectorAll('.gform_page')];
    let activePageCount = 0;
    let currentStep = 0;

    pages.forEach(function (page) {
        if (page.getAttribute('data-conditional-logic') === 'hidden') {
            return;
        }

        activePageCount++;

        if (window.getComputedStyle(page).display !== 'none') {
            currentStep = activePageCount;
        }
    });

    if (!activePageCount || !currentStep) {
        return;
    }

    const progressWrapper = wrapper.querySelector('.gf_progressbar_wrapper');
    const startAtZero = progressWrapper?.getAttribute('data-start-at-zero') === '1';
    const progressStep = startAtZero ? currentStep - 1 : currentStep;
    const percent = Math.floor((progressStep / activePageCount) * 100);
    const bar = wrapper.querySelector('.gf_progressbar_percentage');
    const currentEl = wrapper.querySelector('.gf_step_current_page');
    const countEl = wrapper.querySelector('.gf_step_page_count');
    const progressbar = wrapper.querySelector('.gf_progressbar');

    if (progressbar) {
        progressbar.style.setProperty('--wash-form-pages', String(activePageCount));
    }

    if (bar) {
        bar.style.width = percent + '%';
        bar.className = bar.className.replace(/percentbar_\d+/, 'percentbar_' + percent);

        const percentLabel = bar.querySelector('span');

        if (percentLabel) {
            percentLabel.textContent = percent + '%';
        }
    }

    if (currentEl) {
        currentEl.textContent = String(currentStep);
    }

    if (countEl) {
        countEl.textContent = String(activePageCount);
    }
}

function updateAllWashSystemProgress() {
    document.querySelectorAll('.section--wash-system .wash-system__form .gform_wrapper').forEach(updateWashSystemProgress);
}

function scheduleWashSystemProgressUpdate() {
    [0, 50, 200, 500].forEach(function (delay) {
        window.setTimeout(updateAllWashSystemProgress, delay);
    });
}

function initWashSystemGravityForms() {
    dedupeWashSystemGravityForms();
    applyWashSystemButtonLabels();
    enhanceWashSystemChoiceLabels();
    updateAllWashSystemProgress();
}

function getWashSystemChoiceDescriptions(formContainer) {
    if (!formContainer.dataset.washChoiceDescriptions) {
        return {};
    }

    try {
        return JSON.parse(formContainer.dataset.washChoiceDescriptions);
    } catch (error) {
        return {};
    }
}

function findWashChoiceDescription(descriptions, title, value) {
    if (value && descriptions[value]) {
        return descriptions[value];
    }

    if (title && descriptions[title]) {
        return descriptions[title];
    }

    const normalizedTitle = title.toLowerCase();
    const normalizedValue = (value || '').toLowerCase();

    for (const key in descriptions) {
        if (!Object.prototype.hasOwnProperty.call(descriptions, key)) {
            continue;
        }

        const normalizedKey = key.toLowerCase();

        if (normalizedKey === normalizedTitle || normalizedKey === normalizedValue) {
            return descriptions[key];
        }
    }

    return '';
}

function enhanceWashSystemChoiceLabels() {
    document.querySelectorAll('.section--wash-system .wash-system__form').forEach(function (formContainer) {
        const descriptions = getWashSystemChoiceDescriptions(formContainer);
        const wrapper = formContainer.querySelector('.gform_wrapper');

        if (!wrapper) {
            return;
        }

        wrapper.querySelectorAll('.gfield--type-image_choice .gchoice label.gform-field-label').forEach(function (label) {
            if (label.dataset.washChoiceEnhanced === '1') {
                return;
            }

            const input = label.closest('.gchoice')?.querySelector('.gfield-choice-input');
            const rawText = label.textContent.trim();
            const parts = rawText.split('|');
            const title = parts[0].trim();
            const description = (parts[1] && parts[1].trim())
                || findWashChoiceDescription(descriptions, title, input?.value || '')
                || '';

            label.dataset.washChoiceEnhanced = '1';
            label.textContent = '';

            const titleEl = document.createElement('span');
            titleEl.className = 'wash-choice__title';
            titleEl.textContent = title;
            label.appendChild(titleEl);

            if (description) {
                const descriptionEl = document.createElement('span');
                descriptionEl.className = 'wash-choice__description';
                descriptionEl.textContent = description;
                label.appendChild(descriptionEl);
            }
        });
    });
}

function getWashSystemButtonLabels(formContainer) {
    return {
        next: formContainer.dataset.washBtnNext || 'CONTINUE',
        back: formContainer.dataset.washBtnBack || 'BACK',
        submit: formContainer.dataset.washBtnSubmit || 'SUBMIT',
    };
}

function convertWashFormFooterButton(field, label) {
    if (!field || field.classList.contains('gform_image_button')) {
        return field;
    }

    if (field.tagName === 'BUTTON') {
        field.textContent = label;
        return field;
    }

    if (field.tagName !== 'INPUT' || field.dataset.washBtnConverted === '1') {
        if (label) {
            field.value = label;
        }

        return field;
    }

    const button = document.createElement('button');

    Array.from(field.attributes).forEach(function (attribute) {
        if (attribute.name === 'value') {
            return;
        }

        button.setAttribute(attribute.name, attribute.value);
    });

    button.type = field.type === 'submit' ? 'submit' : 'button';
    button.textContent = label || field.value;
    button.dataset.washBtnConverted = '1';
    field.replaceWith(button);

    return button;
}

function applyWashSystemButtonLabels() {
    document.querySelectorAll('.section--wash-system .wash-system__form').forEach(function (formContainer) {
        const labels = getWashSystemButtonLabels(formContainer);
        const wrapper = formContainer.querySelector('.gform_wrapper');

        if (!wrapper) {
            return;
        }

        wrapper.querySelectorAll('.gform_previous_button').forEach(function (button) {
            convertWashFormFooterButton(button, labels.back);
        });

        wrapper.querySelectorAll('.gform_next_button').forEach(function (button) {
            convertWashFormFooterButton(button, labels.next);
        });

        wrapper.querySelectorAll('.gform_page_footer input.gform_button[type="submit"], .gform_page_footer button.gform_button[type="submit"]').forEach(function (button) {
            convertWashFormFooterButton(button, labels.submit);
        });
    });
}

function scheduleWashSystemFormUpdate() {
    applyWashSystemButtonLabels();
    enhanceWashSystemChoiceLabels();
    scheduleWashSystemProgressUpdate();
}

['gform/frontend_pages/evaluated', 'gform/ajax/post_page_change', 'gform/page_loaded'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleWashSystemFormUpdate);
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWashSystemGravityForms);
} else {
    initWashSystemGravityForms();
}

window.addEventListener('load', scheduleWashSystemFormUpdate);

jQuery(document).on('gform_page_loaded gform_post_render', scheduleWashSystemFormUpdate);
